 <div >
 <div class="header">
    <div class="row main dashboard-title pb-1">
       <div class="col-lg-11 col-md-10 col-xs-10 ">{{ 'serviceSchedule.dealerConfigurationHealth' | translate}}</div> 
       <div class="col-lg-1 col-md-2 col-xs-1 p-0 icon" mat-dialog-close >
        <asp-icon name="ic-20-utility-close-default.svg"></asp-icon>
    </div>
    </div>
    <div class="sub-text pb-1" *ngIf=(dashboardOverlayService.isError)>
        <asp-icon class="dashboard-icon" name="ic-20-feedback-alert-error.svg" color="inherit"
         height="1rem" width="1rem"></asp-icon>
        <span class="errortextclass pl-1">{{ 'serviceSchedule.thisConfigurationRequiresYourAttention' | translate}}</span>
    </div>
 </div>
    <div class="dashboard-details">
    <ng-container *ngFor="let item of data  ">
         <div class="{{item.parentDivClass}}">
             <ng-container *ngFor="let child of item.children">
                <mat-divider [vertical]="child.childdivclass.includes('borderleft')" class="leftdivider"></mat-divider>
                <div class="{{child.childdivclass}} mt-3">
                    <div class="d-flex">
                        <div class="child-title pb-1 ">{{child.name | translate}}</div>
                        <div  class="p-0 warning-icon" style="text-align: end;">
                            <!-- based on condition One of the icon will be active -->
                            <asp-icon *ngIf="child.isButtonRequired && !child.isOptional" class="col-lg-12 col-md-12 dashboard-icon p-0" name="ic-20-feedback-alert-error.svg" color="inherit" 
                            height="1rem" width="1rem"></asp-icon>
                            <asp-icon *ngIf="child.isButtonRequired && child.isOptional" class="col-lg-12 col-md-12 dashboard-icon p-0" name="ic-20-feedback-warning.svg" color="inherit" 
                            height="0.8rem" width="0.8rem"></asp-icon>
                         </div>
                    </div>
                    <div class="child-value">{{child.value}}</div>
                    <div class='col-lg-12 col-md-12 pt-2 pl-0' >
                        <a class='redirectlink ' (click)="redirect(child.redirectpath,child.key)">{{child.buttonvalue | translate}}</a>
                    </div>
                </div>
                <mat-divider [vertical]="child.childdivclass.includes('borderright')" class="leftdivider"></mat-divider>
             </ng-container>
            
        </div> 
    </ng-container>
</div>
</div>
